
$(document).on('click', '.hk-element-sub-option:not(.hk-active)', function () {
  var $this = $(this);
  var tab = parseInt($this.attr('sub_tab'), 10); // 1,2,3...
  var selling_plan = parseInt($('.hk-element-option.hk-active').attr('selling_plan'), 10); // 1,2,3...
  if (!tab) return;
  // Remove active from siblings
  $('.hk-element-sub-option').removeClass('hk-active');
  // Add active to current
  $this.addClass('hk-active');
$('.hk-sub-trigger').hide();
$('.hk-sub-trigger[sub_tab="'+tab+'"]').show();
if (tab == 1){
$('.hk-checkout-button').attr('selling_plan',selling_plan);
$('.hk-AL-sec1-gift1-top .hk-element-title strong').text('Up to 61% Off');
} else {
$('.hk-checkout-button').removeAttr('selling_plan');
$('.hk-AL-sec1-gift1-top .hk-element-title strong').text('Up to 36% Off');
}
});
$(document).on('click', '.hk-element-sub-option.hk-active', function () {
$('.hk-element-sub-option:not(.hk-active)').trigger('click');
});



$(document).on('click', '.hk-element-option', function () {
  var $this = $(this);
  var quantity = parseInt($(this).attr('quantity'), 10); // 1,2,3...
  var selling_plan = parseInt($(this).attr('selling_plan'), 10); // 1,2,3...
  var sub_tab = parseInt($('.hk-element-sub-option.hk-active').attr('sub_tab'), 10); // 1,2,3...


  // Remove active from siblings
  $('.hk-element-option').removeClass('hk-active');

  // Add active to current
  $this.addClass('hk-active');

$('.hk-quantity-trigger').hide();
$('.hk-quantity-trigger[quantity="'+quantity+'"]').show();
$('.hk-checkout-button').attr('quantity',quantity);
var selected_title = $this.find('.hk-option-title').text();
$('.hk-pdp-pdt-sub-heading1 strong').text(selected_title);
if (sub_tab == 1){
$('.hk-checkout-button').attr('selling_plan',selling_plan);
} else {
$('.hk-checkout-button').removeAttr('selling_plan');
}
});



$(document).on("click", "a[href='#ingredients']", function (e) {
  e.preventDefault();
 $('.hk-pdp-popup').addClass('hk-active');
});


$(document).on("click", ".hk-pdp-popup-top .hk-icon-with-text-flex .hk-element-image", function (e) {
  e.preventDefault();
 $('.hk-pdp-popup').removeClass('hk-active');
});

$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.hk-product-flex').scrollIntoView({
    behavior: 'smooth'
  })
});




$(document).ready(async function () {

  const $deliveryEl = $('.hk-pdp-pdt-estimated');

  if (!$deliveryEl.length) return;

  // ===== Date 5 days ahead =====
  const futureDate = new Date();
  futureDate.setDate(futureDate.getDate() + 5);

  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const formattedDate = `${months[futureDate.getMonth()]} ${futureDate.getDate()}, ${days[futureDate.getDay()]}`;

  // ===== Default location =====
  let locationText = 'Your Area';

  try {

    const res = await fetch('https://ipapi.co/json/');
    const data = await res.json();

    if (data) {
      const state = data.region || '';
      const country = data.country_name || '';

      if (state && country) {
        locationText = `${state}, ${country}`;
      } else if (country) {
        locationText = country;
      }
    }

  } catch (e) {

    console.log('Location fetch failed');

  }

  // ===== Replace placeholders =====
  let updatedHtml = $deliveryEl.html()
    .replace('[zipcode]', locationText)
    .replace('[stock_date]', formattedDate);

  $deliveryEl.html(updatedHtml);

});





$(document).on('click', '.hk-checkout-button', function (e) {
    e.preventDefault();

    const $button = $(this);

    const quantity = $button.attr('quantity') || 1;
    const sellingPlan = $button.attr('selling_plan') ? 'true' : 'false';
    const href = $button.attr('href');

    if (!href) {
        return;
    }

    // Current page full URL, including existing query parameters
    const currentPage = window.location.href;

    const separator = href.includes('?') ? '&' : '?';

    const newHref =
        href +
        separator +
        'quantity=' + encodeURIComponent(quantity) +
        '&selling_plan=' + encodeURIComponent(sellingPlan) +
        '&prev_page=' + encodeURIComponent(currentPage);

    window.location.href = newHref;
});